module.exports = __webpack_public_path__ + "963085c8b68e050f225ecf544a93bc9d.png";